/*
Author : Arman Ali
Module: Department
github: https://github.com/Arman-Arzoo
*/
import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import {ResponseApi} from "../BaseApi";
const employeeSlice = createSlice({
    name: 'employeeSection',
    initialState: {
        getAllEmployees: {},
        getEmployeeDetailsByUserId: {},
        updateEmployeeUser: null,
        updateVCardSettings: null,
        createEmployeeUser: null,
        getVCardSettings: {},
        approveCompanyEmployeeDocument: null,
        getAllEmployeeDocuments: [],
        createEmployeeDocValue: {},
        setEmployeeDocValue: {},
        getExtraDataService: {},
        getServiceById:{},
    },
    reducers: {},
    extraReducers: {
        'employeeSection/getAllEmployees/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getAllEmployees = data?.data;
            } else if (status >= 400 && status < 500) {
                toast(t('something_went_wrong'));
            }
        },
        'employeeSection/createEmployeeUser/fulfilled': (state, action) => {
            state.createEmployeeUser = ResponseApi(action.payload)
        },
        'employeeSection/getExtraDataService': (state, action) => {
            const { data, status } = action.payload || {};
        },
        'employeeSection/getEmployeeDetailsByUserId/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getEmployeeDetailsByUserId = data;
            } else if (status >= 400 && status < 500) {
                toast(t('something_went_wrong'));
            }
        },
        'employeeSection/getVCardSettings/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
        },
        'employeeSection/updateVCardSettings/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
        },
        'employeeSection/updateEmployeeUser/fulfilled': (state, action) => {
            state.updateEmployeeUser = ResponseApi(action.payload)
        },
        'employeeSection/approveCompanyEmployeeDocument/fulfilled': (state, action) => {
            state.approveCompanyEmployeeDocument = ResponseApi(action.payload)
        },
        'employeeSection/getAllEmployeeDocuments/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getAllEmployeeDocuments = data.data;
            } else if (status >= 400 && status < 500) {
                toast(t('something_went_wrong'));
            }
        },
        'employeeSection/setEmployeeDocValue/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};

            if (status >= 200 && status < 300) {
                state.setEmployeeDocValue = data;
            } else if (status >= 400 && status < 500) {
                toast(t('something_went_wrong'));
            }
        },
        'employeeSection/createEmployeeDocValue/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};

            if (status >= 200 && status < 300) {
                state.createEmployeeDocValue = data?.data;
            } else if (status >= 400 && status < 500) {
                toast(t('something_went_wrong'));
            }
        },
          'employeeSection/getServiceById/fulfilled': (state, {payload}) => {
            state.getServiceById = ResponseApi(payload);
        },
    },
});

export const {} = employeeSlice.actions;

export default employeeSlice.reducer;
